import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getallapasscode_thunk = createAsyncThunk("getpasscode/get", async () => {
  let response = await api.get("getallapasscode");
  return response.data;
});

export const checkpasscodeexistance_thunk = createAsyncThunk("checkexistance/get", async (passcode) => {
  let response = await api.get("checkpasscodeexistance/" + passcode);
  return response.data;
});

export const checkpasscodeusability_thunk = createAsyncThunk("checkusability/get", async (passcode) => {
  let response = await api.get("checkpasscodeusability/" + passcode);
  return response.data;
});

export const deletepasscode_thunk = createAsyncThunk("passcode/delete", async ({ id, userid, passcode }) => {
  let response = await api.delete("deletepasscode/" + id + "/" + userid + "/" + passcode);
  return response.data;
});

export const generatepasscode_thunk = createAsyncThunk("passcode/create", async ({ userid }) => {
  let response = await api.get("generatePasscode/" + userid);
  return response.data;
});
